import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  morePath?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  morePath,
  moreLabel = "查看全部",
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] uppercase text-accent-600 mb-2">
            <span className="w-6 h-px bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{title}</h2>
        {description && (
          <p className="text-sm md:text-base text-foreground-600 mt-2 max-w-2xl">{description}</p>
        )}
      </div>
      {morePath && (
        <Link
          to={morePath}
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}